//
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`);

//
const chatBotSetting = {

	// 会話履歴を保持するか
	useConversation : false,

	// 不正入力の場合のBAN時間
	banLimit : {
		kanyou : 0, // 何度目まで許すか
		// 悪口やいじわるな質問
		'101':{
			d : 0,
			h : 0,
			m : 0,
			s : 5
		},
		// スパムやいたずら目的
		'102':{
			d : 0,
			h : 0,
			m : 0,
			s : 5
		},
		// より悪質な場合
		'103':{
			d : 0,
			h : 1,
			m : 0,
			s : 0
		}
	}

}



//
import { v4 as uuidv4 } from 'uuid';
import UsagiStepTextRender from '~/assets/js/dom/class/usagi-step-text-render.js';


//
export function doCleanObject(obj) {
	return JSON.parse(JSON.stringify(obj, (key, value) => {
		if(key === '__ob__') {
			return undefined;
		}
		return value;
	}));
}


//
export function doLinkify(text) {
	const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
	return text.replace(emailRegex, '<a href="mailto:$1">$1</a>');
}


//=========================================================================
//  ██████╗ ███╗   ██╗██╗███╗   ██╗██████╗ ██╗   ██╗████████╗
// ██╔═══██╗████╗  ██║██║████╗  ██║██╔══██╗██║   ██║╚══██╔══╝
// ██║   ██║██╔██╗ ██║██║██╔██╗ ██║██████╔╝██║   ██║   ██║   
// ██║   ██║██║╚██╗██║██║██║╚██╗██║██╔═══╝ ██║   ██║   ██║   
// ╚██████╔╝██║ ╚████║██║██║ ╚████║██║     ╚██████╔╝   ██║   
//  ╚═════╝ ╚═╝  ╚═══╝╚═╝╚═╝  ╚═══╝╚═╝      ╚═════╝    ╚═╝   
//=========================================================================
export function onInput(context, e) {
	context.onAdjustHeight(e.target, false);
}

export function onAdjustHeight(context, textarea, reset = false) {

	if(reset) {

		textarea.value = '';
		textarea.style.height = 'auto';
		const scrollHeight = textarea.scrollHeight;
		textarea.style.height = scrollHeight + 'px';
		context.height = scrollHeight + 'px';

	} else {

		textarea.style.height = 'auto';
		const scrollHeight = textarea.scrollHeight;
		textarea.style.height = scrollHeight + 'px';

		const lineHeightPx = parseFloat(getComputedStyle(textarea).lineHeight);
		const fontSize = parseFloat(getComputedStyle(textarea).fontSize);
		const maxHeight = parseFloat(getComputedStyle(textarea).maxHeight);
		const lineNum = scrollHeight / lineHeightPx;

		if(fontSize * lineNum >= maxHeight) {
			context.isMaxHeightReached = true;
		} else {
			context.isMaxHeightReached = false;
		}

		context.height = scrollHeight + 'px';
	}

}

export function onKeyDown(e) {
	if(!e.shiftKey && !DETECT.device.any) {
		e.preventDefault();
	}
}

export function onKeyUp(context, e) {
	if(!context.composing && !e.shiftKey && !context.isChatTalking && !DETECT.device.any ) {
		context.onSubmit();
	}
}

export function onCompositionStart(context) {
	context.composing = true;
	if(context.compositionTimeout) {
		clearTimeout(context.compositionTimeout);
	}
}

export function onCompositionEnd(context) {
	context.compositionTimeout = setTimeout(() => {
		context.composing = false;
	}, 150);
}




//=========================================================================
// ███████╗ █████╗  ██████╗ 
// ██╔════╝██╔══██╗██╔═══██╗
// █████╗  ███████║██║   ██║
// ██╔══╝  ██╔══██║██║▄▄ ██║
// ██║     ██║  ██║╚██████╔╝
// ╚═╝     ╚═╝  ╚═╝ ╚══▀▀═╝ 
//=========================================================================
export async function onSubmitFAQ(context,q,a,currentTarget) {

	//
	if (context.isChatTalking || !context.chatAi.faq.loaded ) return;

	//
	$html.classList.add('is-chat-start');

	//
	context.$store.dispatch('updateFaqStatus', { question: q, status: true });

	//
	const uuid = uuidv4();

	// 会話履歴に登録
	if( chatBotSetting.useConversation ){
		context.conversation.push({
			id: uuid,
			role: "user",
			content: q
		});
		context.conversation.push({
			role: "assistant",
			content: a
		});
	}

	//
	const output = {
		"user": {
			id: uuid,
			active: false,
			content: q
		},
		"assistant": {
			icon : {
				el : null,
				tl : null
			},
			content: ""
		}
	}
	context.output.push(output);
	context.isChatTalking = true;

	//
	await context.$nextTick();

	//=====================================
	// Icon Animate Start
	//=====================================
	if( context.$refs['output-icon-' + output.user.id] ){
		output.assistant.icon.el = context.$refs['output-icon-' + output.user.id][0];
		output.assistant.icon.tl = gsap.timeline({ repeat: 2, paused: true });
		output.assistant.icon.tl.to( output.assistant.icon.el, {
			scale: 0.8,
			duration: 1,
			ease: "power2.inOut"
		});
		output.assistant.icon.tl.to( output.assistant.icon.el, {
			scale: 1,
			duration: 1,
			ease: "power2.inOut"
		});
		output.assistant.icon.tl.play();
	}

	// const speak = (text) => {
	// 	const synth = window.speechSynthesis;
	// 	const utterance = new SpeechSynthesisUtterance(text);
	// 	utterance.lang = 'ja-JP'; // 日本語に設定
	// 	synth.speak(utterance);
	// };
	// speak(a);

	context.message = a;
	context.onTypeAnimation(output);

}



//=========================================================================
//  ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
// ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
// ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║   
// ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║   
// ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║   
//  ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝   
//=========================================================================
export async function onSubmit(context) {

	//
	if (context.isChatTalking || !context.inputText.trim() || !context.chatAi.setting.loaded) return;
	$html.classList.add('is-chat-start');

	//
	const lang = context.$i18n.locale ? context.$i18n.locale : 'ja';

	//
	const uuid = uuidv4();
	context.conversation.push({
		id: uuid,
		role: "user",
		content: context.inputText
	});

	//
	const output = {
		"user": {
			id: uuid,
			active: false,
			content: context.inputText
		},
		"assistant": {
			icon : {
				el : null,
				tl : null
			},
			content: ""
		}
	}
	context.output.push(output);
	context.isChatTalking = true;
	context.inputText = '';
	context.onAdjustHeight(context.$refs.textarea, true);
	if (stylePageScroll.chatBox){
		stylePageScroll.chatBox.onScrollToBottom( context );
	}

	await context.$nextTick();

	//=====================================
	// Icon Animate Start
	//=====================================
	if( context.$refs['output-icon-' + output.user.id] ){
		output.assistant.icon.el = context.$refs['output-icon-' + output.user.id][0];
		output.assistant.icon.tl = gsap.timeline({ repeat: 2, paused: true });
		output.assistant.icon.tl.to( output.assistant.icon.el, {
			scale: 0.8,
			duration: 1,
			ease: "power2.inOut"
		});
		output.assistant.icon.tl.to( output.assistant.icon.el, {
			scale: 1,
			duration: 1,
			ease: "power2.inOut"
		});
		output.assistant.icon.tl.play();
	}

	//
	context.onCheckBan();

	//
	if (context.chatAi.ban.flag) {
		let code = localStorage.getItem('b-code', code ) ? localStorage.getItem('b-code', code ) : 100;
		context.message = context.chatAi.data.error["ban"][ lang ] + code;
		context.onTypeAnimation(output);
		return;
	}

	//
	const setting = context.doCleanObject(context.chatAi.setting.array);

	//
	if( lang === 'en'){
		setting.push({
			role: 'system',
			content: 'あなたは基本的に英語で回答するアシスタントです。'
		});
	} else {
		setting.push({
			role: 'system',
			content: 'あなたは基本的に日本語で回答するアシスタントです。'
		});		
	}

	//
	const messages = [...setting, ...context.conversation];
	const requestBody = {
		model: context.mode,
		messages: messages
	};

	console.log( requestBody, context.conversation );

	try {

		//====================================
		// 回答の取得
		//====================================
		const response = await fetch( envSet.api.response, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(requestBody)
		});

		if (!response.ok) {
			if (response.status === 402) {
				context.message = context.chatAi.data.error["limit"][ lang ];
				context.onTypeAnimation(output);
			} else {
				context.message = context.chatAi.data.error["network"][ lang ];
				context.onTypeAnimation(output);
			}
			throw new Error(`Network response was not ok: ${response.statusText}`);
		}

		const data = await response.json();

		//
		let code = localStorage.getItem('b-code', code ) ? localStorage.getItem('b-code', code ) : 100;

		//
		if (data.choices && data.choices.length > 0 && data.choices[0].message) {

			context.message = data.choices[0].message.content;

			//====================================
			// BAN
			//====================================
			const errors = ["{{ERROR:101}}", "{{ERROR:102}}", "{{ERROR:103}}"];
			errors.forEach(error => {
				if (context.message.includes(error)) {
					console.log(`文字列に${error}が含まれています。`);
					context.onBan(error);
				}
			});

			//
			if (!context.chatAi.ban.flag) {

				context.conversation.push({
					role: "assistant",
					content: context.message
				});
				context.onTypeAnimation(output);

			} else {

				context.message = context.chatAi.data.error["ban"][ lang ] + code;
				context.onTypeAnimation(output);

			}

		} else {

			context.message = context.chatAi.data.error["ban"][ lang ] + code;
			context.onTypeAnimation(output);

		}

		context.response = data;

	} catch (error) {

		context.message = context.chatAi.data.error["server"][ lang ];
		context.onTypeAnimation(output);

	}

}



export function onDestroyRenderer(context) {

	if (context.renderer) {
		context.renderer.onDestroy();
		context.renderer = null;
	}
	for (let i = 0; i < context.output.length; i++) {
		const output = context.output[i];
		if( output.assistant.icon.tl ){
			output.assistant.icon.tl.kill();
			output.assistant.icon.tl = null;
		}
	}

}


//
function replaceText( aText, bText, locale, message ) {
	return message.replace(/{{(.*?)}}/g, (match, p1) => {
		if (bText[locale] && bText[locale].hasOwnProperty(p1)) {
			return bText[locale][p1];
		}
		if (aText.hasOwnProperty(p1)) {
			return aText[p1];
		}
		return p1;
	});
}


//
export async function onTypeAnimation(context, output) {
	await context.$nextTick();

	output.user.active = true;

	const lang = context.$i18n.locale ? context.$i18n.locale : 'ja';

	if (context.renderer) {
		context.renderer.onDestroy();
		context.renderer = null;
	}

	//
	let editorElement = context.$refs['output-' + output.user.id][0];
	let markdownContent = context.$md.render( replaceText( context.chatAi.data.replaceText.a, context.chatAi.data.replaceText.b, lang, context.message ) );

	//
	let typeSpeed = 10;
	let typeMax = 5000;
	if( lang === 'ja' ){
		typeSpeed = 25;
	}

	//
	context.renderer = new UsagiStepTextRender({
		speed: typeSpeed,
		max: typeMax,
		inputElement: markdownContent,
		outputElement: editorElement,
		onUpdate: () => {
			if (stylePageScroll.chatBox){
				stylePageScroll.chatBox.onScrollToBottomInterval( context );
			}
		},
		onComplete: () => {

			output.assistant.content = markdownContent;
			context.isChatTalking = false;

			if (stylePageScroll.chatBox){
				stylePageScroll.chatBox.onScrollToBottom( context );
			}

			//=====================================
			// Icon Animate Stop
			//=====================================
			if( context.$refs['output-icon-' + output.user.id] ){
				if( output.assistant.icon.tl ){
					output.assistant.icon.tl.kill();
					output.assistant.icon.tl = null;
					gsap.to( output.assistant.icon.el, {
						scale: 1,
						duration: 1,
						ease: "power2.inOut"
					});
				}
			}

		}
	});
	context.renderer.onInit();
}





//=========================================================================
// ██████╗  █████╗ ███╗   ██╗
// ██╔══██╗██╔══██╗████╗  ██║
// ██████╔╝███████║██╔██╗ ██║
// ██╔══██╗██╔══██║██║╚██╗██║
// ██████╔╝██║  ██║██║ ╚████║
// ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═══╝
//=========================================================================

//
export function onBan( context, error ){

	// 何度めのBANか
	let banCount = 1;
	if( localStorage.getItem('b-count') ){
		banCount = Number( localStorage.getItem('b-count') ) + 1;
	}
	localStorage.setItem('b-count', banCount );

	if( banCount >= chatBotSetting.banLimit.kanyou ){

		//
		let code = '100';
		switch( error ){
			case '{{ERROR:101}}':
				// 悪口やいじわるな質問
				code = '101'; 
			break;
			case '{{ERROR:102}}':
				// スパムやいたずら目的
				code = '102';
			break;
			case '{{ERROR:103}}':
				// より悪質な場合
				code = '103';
			break;
		}

		const banLimitDay  = chatBotSetting.banLimit[code].d * Math.min( banCount, 12 );
		const banLimitHour = chatBotSetting.banLimit[code].h * Math.min( banCount, 12 );
		const banLimitMin  = chatBotSetting.banLimit[code].m * Math.min( banCount, 12 );
		const banLimitSec  = chatBotSetting.banLimit[code].s * Math.min( banCount, 12 );
		localStorage.setItem( 'b-code', code );

		//
		const banLimit = (banLimitSec * 1000) + (banLimitMin * 60 * 1000) + (banLimitHour * 60 * 60 * 1000) + (banLimitDay * 24 * 60 * 60 * 1000);

		//
		const banUntil = Date.now() + banLimit;
		localStorage.setItem('b-stat', 'true');
		localStorage.setItem('b-stat-until', banUntil.toString());
		localStorage.setItem('b-limit', banLimit/1000 );
		context.$store.commit("UPDATE_CHAT_BAN_FLAG", true);

		//
		setTimeout(() => {
			context.onUnBan();
		}, banLimit );

	}

}


export function onUnBan( context ){
	localStorage.removeItem('b-stat');
	localStorage.removeItem('b-limit');
	localStorage.removeItem('b-stat-until');
	context.$store.commit("UPDATE_CHAT_BAN_FLAG", false);
}


export function isBanned() {
	const banUntil = parseInt(localStorage.getItem('b-stat-until'), 10);
	return !isNaN(banUntil) && banUntil > Date.now();
}


export function onCheckBan(context) {

	if( context.isBanned() ) {

		context.$store.commit("UPDATE_CHAT_BAN_FLAG", true);
		const banUntil = parseInt(localStorage.getItem('b-stat-until'), 10);
		setTimeout(() => {
			context.onUnBan();
		}, banUntil - Date.now() );

	} else {
		context.$store.commit("UPDATE_CHAT_BAN_FLAG", false);
		context.onUnBan();
	}

}











